import style from '../../serviceRecommendation.module.scss';

type PartCardFooterWrapperProp = {
  children: React.ReactNode;
};

export const ServiceRecommendationPartCardFooterWrapper = ({
  children
}: PartCardFooterWrapperProp) => {
  return <div className={`${style['part-card-footer']} mt-2`}>{children}</div>;
};
